import { render } from "./FilmLink.vue?vue&type=template&id=622ac7ec&scoped=true"
import script from "./FilmLink.vue?vue&type=script&lang=js"
export * from "./FilmLink.vue?vue&type=script&lang=js"

import "./FilmLink.vue?vue&type=style&index=0&id=622ac7ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-622ac7ec"]])

export default __exports__